import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText, Headline, Subhead } from '../../../atoms'
import { useMediaQuerySize } from '../../../hooks'
import { BodyTextSize, HeadlineSize, SubheadSize } from '../../../styles'
import { ThemeType } from '../../../utils/themes/ThemeProvider'
import { tID } from '../../../utils/utils'
import { PathwaysTestimonialsCarousel } from '../pathwaysTestimonialsCarousel/PathwaysTestimonialsCarousel'

const SectionContainer = styled.View<{ theme: ThemeType; backgroundColor?: string }>(({ theme, backgroundColor }) => ({
  backgroundColor: theme.isAuroraTheme ? 'transparent' : backgroundColor || theme.colors.backgroundSecondary,
  padding: theme.breakpoints.isMobileSized ? '64px 0' : '96px 0',
}))

const TitleContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginBottom: theme.breakpoints.isMobileSized ? '53px' : '70px',
  padding: theme.breakpoints.isMobileSized ? '0 16px' : '0px',
}))

export const PathwaysTestimonialsSection: FunctionComponent<{ backgroundColor?: string }> = ({ backgroundColor }) => {
  const { colors } = useTheme()
  const { isMobileSized } = useMediaQuerySize()

  return (
    <SectionContainer testID={tID('PathwaysTestimonialsSection')} backgroundColor={backgroundColor}>
      <TitleContainer>
        {isMobileSized ? (
          <Subhead
            level='2'
            size={SubheadSize.MEDIUM}
            testID={tID('PathwaysTestimonialsSection-pathwaysTestimonialTitleContainer')}
            textAlign='center'
            text={
              <FormattedMessage
                description='Header text to inform user of testimonials title'
                defaultMessage='Lyra offers life-changing support for {everyone}'
                values={{
                  everyone: (
                    <Subhead
                      text={
                        <FormattedMessage
                          defaultMessage='everyone'
                          description='Header text to inform user of testimonials title for everyone'
                        />
                      }
                      color={colors.textActive}
                      size={SubheadSize.MEDIUM}
                    />
                  ),
                }}
              />
            }
          />
        ) : (
          <Headline
            level='2'
            size={HeadlineSize.SMALL}
            testID={tID('PathwaysTestimonialsSection-pathwaysTestimonialTitleContainer')}
            textAlign='center'
            text={
              <FormattedMessage
                description='Header text to inform user of testimonials title'
                defaultMessage='Lyra offers life-changing support for {everyone}'
                values={{
                  everyone: (
                    <BodyText
                      text={
                        <FormattedMessage
                          defaultMessage='everyone'
                          description='Header text to inform user of testimonials title for everyone'
                        />
                      }
                      color={colors.textActive}
                      size={BodyTextSize.XLARGE}
                      bold
                    />
                  ),
                }}
              />
            }
          />
        )}
      </TitleContainer>
      <PathwaysTestimonialsCarousel />
    </SectionContainer>
  )
}
